export enum Role {
  ACCOUNT = 'ACCOUNT',
  GROUP = 'GROUP',
  ADMINISTRATOR = "ADMINISTRATOR"
}
